(function($) {
  var __ = {
      
    window: $(window),

    // Scene Controller
    controller: false,

    pageParallax : function(){
      __.controller = new ScrollMagic.Controller();

        console.log('setup scrollmagic scene');
      },

      setup: function() {
          __.pageParallax();
          __.addHandlers();
      },


  addHandlers: function() {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    var is_iPad = navigator.userAgent.match(/iPad/i) != null;

    // var slideAnimationForward = function() {
    //     $('.box-29').animate({
    //       left: '-100%'
    //     }, 500, function() {
    //       $('.box-29').css('left', '0%');
    //       $('.box-29').appendTo('.ssocial_content-photo-container');
    //     });
    
    //     $('.box-29').next().animate({
    //         left: '0%'
    //     }, 500);
  
    //     setTimeout(function() {
    //       $('.box-29').addClass('invisible').removeClass('visible');
    //       $($('.box-29')[i]).removeClass('invisible').addClass('visible');
    //     }, 200);
    // };
  
  //   var slideAnimationBackward= function() {
  //     $('.box-29').animate({
  //       left: '100%'
  //     }, 500, function() {
  
  //       if ($('.box-29').index() !== 0) {
  //         $('.box-29').css('left', '-150%');
  //       } else {
  //         $('.box-29').css('left', '-0%');
  //       }
    
  //       $('.box-29').appendTo('.ssocial_content-photo-container');
  
  //     });
  
  //     $('.box-29').next().animate({
  //         left: '0%'
  //     }, 500);
  
  //     setTimeout(function() {
  //       $('.box-29').addClass('invisible').removeClass('visible');
  //       $($('.box-29')[i]).removeClass('invisible').addClass('visible');
  //     }, 200);
  // };
  
    // var preventScroll = function() {
    //   $('body').css('overflow', 'hidden');
    // };
  
    // var enableScroll = function() {
    //   $('body').css('overflow', 'scroll');
    // };
  
    // var transitionIcons = function(i) {
    //   $('.circle').removeClass('active');
    //   $($('.circle')[i]).addClass('active');
    //   $('.circle-text').removeClass('invisible').addClass('visible');
    //   $($('.circle-text')[i]).addClass('invisible').removeClass('visible');
    //   $('.box-32-inner').addClass('invisible').removeClass('visible');
    //   $($('.box-32-inner')[i]).removeClass('invisible').addClass('visible');
    // };
  
  
    // var transitionMobileIcons = function(i) {
    //   $('.circle-mobile-2').removeClass('active');
    //   $($('.circle-mobile-2')[i]).addClass('active');
    // }
  
    // var i = 0
    // var scrollIsDisabled = false
    // var ableToSlideAnimation = false
  
    // if (!isMobile) {
    //   $(window).on('mousewheel', function(e) {
    //     var elementOffset = ($('.social_campaign-strategy-section-2').offset().top);
    //     var elementAtTop = ($(window).scrollTop() > elementOffset);
    //     var onFirstItem = (i === 0);
    //     var onLastItem = (i === 3);
    
    //     var elem = document.querySelector('.social_campaign-strategy-section-2');
    //     var bounding = elem.getBoundingClientRect();
    
    //     if (elementAtTop && (bounding.top <= 0) && (bounding.top > -70) && onFirstItem) {
    //       preventScroll()
    //       scrollIsDisabled = true
    //       setTimeout(function() {
    //         ableToSlideAnimation = true
    //       }, 1000)
    //     } else if (onLastItem) {
    //       enableScroll(scrollIsDisabled)
    //       scrollIsDisabled = false
    //         if (bounding.top < -800 || bounding.top > 800) {
    //           i = 0
    //           transitionIcons(i)
    //           ableToSlideAnimation = false
    //         };
    //       };
    
        
    //       clearTimeout($.data(this, 'scrollTimer'));
    
    //         $.data(this, 'scrollTimer', setTimeout(function() {
    //           if (scrollIsDisabled) {
    //               if (e.originalEvent.wheelDelta && ableToSlideAnimation) {
    //                 i++ 
    //                 transitionIcons(i)
    //                 slideAnimationForward()
    //               };
    //           };
    //         }, 50));
    //   }) ;
    // };
  
  
  
    // previousI = 0
    // nextI = 0
  
    // if (isMobile) {
    //   $('.circle-container-mobile').on('click', function(e) {
    //     var tappedItemIndex = $('.circle-container-mobile').index(this)
  
    //     if (tappedItemIndex === 0) {
    //       is_iPad ? $('.box-42').animate({'right': '-35vw'}) : $('.box-42').animate({'right': '-35vw'})
    //     } else if (tappedItemIndex === 1) {
    //       is_iPad? $('.box-42').animate({'right': '-15vw'}) : $('.box-42').animate({'right': '-25vw'})
    //     } else if (tappedItemIndex === 2) {
    //       is_iPad ? $('.box-42').animate({'right': '5vw'}) : $('.box-42').animate({'right': '5vw'})
    //     } else if (tappedItemIndex === 3) {
    //       is_iPad ? $('.box-42').animate({'right': '10vw'}) : $('.box-42').animate({'right': '40vw'})
    //     } 
  
    //     i = tappedItemIndex
    //     nextI = i
    //     if (previousI < nextI) {
    //       slideAnimationForward()
    //       transitionMobileIcons(i)
    //     } else if (previousI > nextI) {
    //       i = tappedItemIndex
    //       slideAnimationBackward()
    //       transitionMobileIcons(i)
    //     };
  
    //     previousI = nextI
  
    //   });
    // };

    
    $('.go-to-contact').click(function() {
      $('html,body').animate({
          scrollTop: $(".social_campaign-contact-section").offset().top},
          'slow');
    });
    
    var photoSlide = $('.slider-photo-container').slick({
      prevArrow: false,
      nextArrow: false,
      autoplaySpeed: 10000,
      asNavFor: '.caption-container'
    });

    var captionSlide = $('.caption-container').slick({
      prevArrow: false,
      nextArrow: false,
      fade: true,
      autoplaySpeed: 10000,
      asNavFor: '.slider-photo-container'
    });

    function isScrolledIntoView(elem) {
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      
      var eleHeight = elem.outerHeight();
      var elemTop = elem.offset().top;
      var elemBottom = elemTop + eleHeight;
      var topOffset = eleHeight * 2 / 3;
      var bottomOffset = eleHeight * 2 / 3;
  
      //first two conditions check any part of element is in view, last two conditions added offset when scrolled approaching from top and bottom
      var res = elemBottom > viewportTop && elemTop < viewportBottom && viewportTop > elemTop - $(window).height() + topOffset && viewportBottom < elemBottom + $(window).height() - bottomOffset;
      return res;
    }

    var slideTriggered = false;

    $(window).scroll(function(){
      if (!slideTriggered && isScrolledIntoView($('.social_campaign-strategy-section'))) {
        photoSlide.slick('slickPlay');
        captionSlide.slick('slickPlay');
        slideTriggered = true;
      } 
    });

    photoSlide.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $('.slide-control-desktop .nav-dot').removeClass('active');
      $('.slide-control-desktop .nav-dot').eq(nextSlide).addClass('active');
      $('.slide-control-mobile .circle-container-mobile').removeClass('active');
      $('.slide-control-mobile .circle-container-mobile').eq(nextSlide).addClass('active');

      $('.slide-control-mobile').attr('class', function(i, c){
        return c.replace(/(^|\s)active-\S+/g, ' active-' + nextSlide);
      });
      
      if(nextSlide > currentSlide) {
        $('.control-arrow').eq(currentSlide).removeClass('forward').addClass('backward');
      } else {
        $('.control-arrow').eq(currentSlide-1).removeClass('backward').addClass('forward');
      }
      
    });

    $('.slide-control-desktop .nav-dot').on('click', function(){
      var gotoIndex = $('.slide-control-desktop .nav-dot').index($(this));
      photoSlide.slick('slickGoTo', gotoIndex);
      captionSlide.slick('slickGoTo', gotoIndex);
    });

    $('.circle-container-mobile').on('click', function(){
      var gotoIndex = $('.circle-container-mobile').index($(this));
      photoSlide.slick('slickGoTo', gotoIndex);
      captionSlide.slick('slickGoTo', gotoIndex);
    });

    photoSlide.hover(function(){
      captionSlide.slick('slickPause');
    }, function() {
      captionSlide.slick('slickPlay');
    });

    captionSlide.hover(function(){
      photoSlide.slick('slickPause');
    }, function() {
      photoSlide.slick('slickPlay');
    });

  }
};
window._animations.socialCampaign1 = __;

})(jQuery); // Fully reference jQuery after this point.